import StoreCoupons from './StoreCoupons'

export default StoreCoupons
